import { render, staticRenderFns } from "./TradeCartSummary.vue?vue&type=template&id=5f7d01e3&"
import script from "./TradeCartSummary.vue?vue&type=script&lang=js&"
export * from "./TradeCartSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports